import BulkOperationsController from './BulkOperationsController'
import {arrayToSet} from '../../../atUtils'

export default class BulkChangeAssignmentsTasksController extends BulkOperationsController {
    constructor({
        onSuccess = () => {},
        onProgress = () => {},
        onFailure = () => {},
    }) {
        super({
            method: 'TaskManagementService.assignTasksToUsers',
            initialResult: {
                taskIds: [],
                userIds: {},
                managementAssignments: {},
                viewerSettings: {},
            },
            combineFn: (result, chunkResult) => {
                return {
                    taskIds: [...result.taskIds, ...chunkResult.taskIds],
                    userIds: {
                        ...result.userIds,
                        ...arrayToSet(chunkResult.userIds)
                    },
                    managementAssignments: chunkResult.managementAssignments,
                    viewerSettings: chunkResult.viewerSettings,
                }
            },
            onSuccess,
            onProgress,
            onFailure,
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/controller/BulkChangeAssignmentsTasksController.js